"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _types = require("../users/types");

Object.defineProperty(exports, "Id", {
  enumerable: true,
  get: function get() {
    return _types.Id;
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvYXV0aC90eXBlcy5qcyJdLCJuYW1lcyI6WyJJZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7a0JBQ1FBLEUiLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuZXhwb3J0IHtJZH0gZnJvbSBcIi4uL3VzZXJzL3R5cGVzXCJcbmV4cG9ydCB0eXBlIFN0YXRlID0ge1xuICAraXNBbm9ueW1vdXM6IGJvb2xlYW4sXG4gICtlbWFpbDogP3N0cmluZyxcbiAgK3VpZDogc3RyaW5nLFxufVxuXG5leHBvcnQgdHlwZSBQcm9wcyA9IGFueVxuZXhwb3J0IHR5cGUgU2VsZWN0PFQ+ID0gKFN0YXRlLCBhbnkpID0+IFRcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/auth/types.js
// module id = 216
// module chunks = 0